namespace Ir.Components.Workbook.Settings.Items.DecimalPlacesSetting {
    export interface IParams {
        value: KnockoutObservable<number>;
        disabled?: KnockoutObservable<boolean> | boolean;
        metricField?: MetricField,
        /** default is -1 */
        basedOnMetricValue?: number;
    }
    interface IViewModel {
        selectBoxOptions: DevExpress.ui.dxSelectBox.Properties;
        label: string;
        disabled?: KnockoutObservable<boolean> | boolean;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        if ((params as any).config) {
            params = (params as any).config;
        }

        this.label = "Decimal Places";
        this.disabled = params.disabled === undefined ? false : params.disabled as any;
        let metricDecimalPlaces = "";
        if (params.metricField) {
            metricDecimalPlaces = ` (${params.metricField?.metricContainer?.metricObject?.decimalPlaces})`
        }
        if (params.basedOnMetricValue === undefined) {
            params.basedOnMetricValue = -1;
        }
        this.selectBoxOptions = {
            displayExpr: 'text',
            valueExpr: 'value',
            value: params.value,
            items: [
                { value: params.basedOnMetricValue, text: 'Based on Metric' + metricDecimalPlaces },
                { value: 0, text: 'None(0)' },
                { value: 1, text: 'One(0.0)' },
                { value: 2, text: 'Two(0.00)' },
                { value: 3, text: 'Three(0.000)' },
                { value: 4, text: 'Four(0.0000)' },
                { value: 5, text: 'Five(0.00000)' }
            ],
            width: 140,
            disabled: this.disabled as any,
        };
    }
}